import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { WebhookScreen } from '@/features/webhooks/routes/webhook-screen'
import { WebhooksScreen } from '@/features/webhooks/routes/webhooks-screen'

/** The list, or — with ?webhook=<id> — that webhook's settings and run history. */
export const Route = createFileRoute('/settings/webhooks')({
  validateSearch: z.object({ webhook: z.string().optional() }),
  component: Webhooks,
})

function Webhooks() {
  const { webhook } = Route.useSearch()
  return webhook ? <WebhookScreen id={webhook} /> : <WebhooksScreen />
}
